import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase';

/**
 * Upload an image to Firebase Storage
 * @param {File} file - The image file to upload
 * @param {string} folder - The folder path (e.g., 'articles/my-article-slug')
 * @returns {Promise<string>} - The download URL of the uploaded image
 */
export async function uploadImage(file, folder = 'articles') {
  // Generate a unique filename
  const timestamp = Date.now();
  const sanitizedName = file.name.replace(/[^a-zA-Z0-9.-]/g, '_');
  const filename = `${timestamp}_${sanitizedName}`;
  const path = `${folder}/${filename}`;

  // Create storage reference
  const storageRef = ref(storage, path);

  // Upload the file
  const snapshot = await uploadBytes(storageRef, file);

  // Get the download URL
  const downloadURL = await getDownloadURL(snapshot.ref);

  return downloadURL;
}

/**
 * Upload an image specifically for article content
 * @param {File} file - The image file to upload
 * @param {string} articleSlug - The article slug for organization
 * @returns {Promise<string>} - The download URL
 */
export async function uploadArticleImage(file, articleSlug = 'general') {
  const folder = `articles/${articleSlug}`;
  return uploadImage(file, folder);
}
